import { PushPin, StarBorder } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { useSupplierTitle } from "@ryde/redux";
import { IRideDto, parseBoolean } from "@ryde/shared";

import { RideBottomBlockStyled } from "../ride.styled";
import { RideAreaGroupSupplierIndicatorsIconRow } from "./ride-area-group-supplier-source-indicators.styled";

export interface IRideAreaGroupSupplierSourceIndicatorProps {
  rideDto?: Partial<IRideDto>;
}

export const RideAreaGroupSupplierSourceIndicator: FC<
  IRideAreaGroupSupplierSourceIndicatorProps
> = ({ rideDto }) => {
  const { t } = useTranslation();

  const isNewStatusPreservedByAreaSupplier = parseBoolean(
    rideDto?.metadata?.isNewStatusPreservedByAreaSupplier,
  );

  const supplierIdFromAreaGroup = rideDto?.metadata?.supplierIdFromAreaGroup;

  const showNewStatusPin = isNewStatusPreservedByAreaSupplier;

  const showPricePriority = Boolean(supplierIdFromAreaGroup);

  const { title: pricePrioritySupplierTitle } = useSupplierTitle(
    supplierIdFromAreaGroup,
  );

  if (!showNewStatusPin && !showPricePriority) {
    return null;
  }

  return (
    <RideBottomBlockStyled className="area-group-supplier-source-indicator">
      <RideAreaGroupSupplierIndicatorsIconRow>
        {showNewStatusPin && (
          <FramerTooltip
            content={t(
              "ride.INDICATORS.isNewStatusPreservedByAreaSupplierTooltip",
            )}
            rtlStrippedBottomLeftPlacement
          >
            <span>
              <PushPin className="ride-indicators__ag-pin" />
            </span>
          </FramerTooltip>
        )}

        {showPricePriority && (
          <FramerTooltip
            content={t("ride.INDICATORS.supplierIdFromAreaGroupTooltip", {
              name: pricePrioritySupplierTitle,
              id: supplierIdFromAreaGroup,
            })}
            rtlStrippedBottomLeftPlacement
          >
            <span>
              <StarBorder className="ride-indicators__ag-priority" />
            </span>
          </FramerTooltip>
        )}
      </RideAreaGroupSupplierIndicatorsIconRow>
    </RideBottomBlockStyled>
  );
};
